import React, { Component, CSSProperties, HTMLProps } from 'react';
import classNames from 'classnames';

interface ColumnsPropTypes {
  gap?: boolean | number | string | Array<number | string>;
  className?: string;
  multiline?: boolean;
  children: React.ReactNode;
  mobile: boolean;
  style?: CSSProperties;
}

export class Columns extends Component<ColumnsPropTypes> {
  static defaultProps = {
    mobile: false,
    style: {},
  };

  render() {
    const {
      props: { gap, className, multiline, mobile, style },
    } = this;

    let buildGap: Array<string> | string = [];
    if (gap && Array.isArray(gap)) {
      buildGap = gap.map(g => 'is-' + g);
    } else {
      buildGap = gap ? 'is-' + gap : '';
    }

    const classes = classNames(
      className,
      'columns',
      gap === false && 'is-gapless',
      gap && typeof gap !== 'boolean' && 'is-variable',
      buildGap,
      multiline && 'is-multiline',
      mobile && 'is-mobile',
    );

    return (
      <div className={classes} style={style}>
        {this.props.children}
      </div>
    );
  }
}

interface ColumnPropTypes {
  size?: string | number | Array<string | number>;
}

export class Column extends Component<
  ColumnPropTypes & Omit<HTMLProps<HTMLDivElement>, 'size'>
> {
  render() {
    const {
      props: { size, className, ...htmlAttr },
    } = this;

    let buildSize: Array<string> | string = [];
    if (size && Array.isArray(size)) {
      buildSize = size.map(g => 'is-' + g);
    } else {
      buildSize = size ? 'is-' + size : '';
    }

    const classes = classNames(className, 'column', buildSize);

    return (
      <div {...htmlAttr} className={classes}>
        {this.props.children}
      </div>
    );
  }
}
